import axios from 'axios';
import { getPortalBackendBaseUrl } from '../hooks/apiUrlResolver';

export interface SubscriptionData {
  key: string;
  key_type: string;
  key_id: string;
  user_id: string;
  org_id: string;
  org_name: string;
  creation_time: string;
  expiration_time: string;
  status: string;
}

const getSubscriptionDetails = async (orgIds: string[]): Promise<SubscriptionData[]> => {
  const response = await axios.get(`${getPortalBackendBaseUrl()}/subscription-details?org_ids=${orgIds.join(',')}`, {
    withCredentials: true,
  });
  return response.data;
};

export default getSubscriptionDetails;